'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Grid;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _group = require('@vx/group');

var _Rows = require('./Rows');

var _Rows2 = _interopRequireDefault(_Rows);

var _Columns = require('./Columns');

var _Columns2 = _interopRequireDefault(_Columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Grid(_ref) {
  var top = _ref.top,
      left = _ref.left,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      stroke = _ref.stroke,
      strokeWidth = _ref.strokeWidth,
      strokeDasharray = _ref.strokeDasharray,
      numTicksRows = _ref.numTicksRows,
      numTicksColumns = _ref.numTicksColumns,
      rowLineStyle = _ref.rowLineStyle,
      columnLineStyle = _ref.columnLineStyle;

  return _react2.default.createElement(
    _group.Group,
    { className: (0, _classnames2.default)('vx-grid', className), top: top, left: left },
    _react2.default.createElement(_Rows2.default, {
      className: className,
      scale: yScale,
      width: width,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      numTicks: numTicksRows,
      style: rowLineStyle
    }),
    _react2.default.createElement(_Columns2.default, {
      className: className,
      scale: xScale,
      height: height,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      numTicks: numTicksColumns,
      style: columnLineStyle
    })
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@vx/grid/build/grids/Grid.js
// module id = ./node_modules/@vx/grid/build/grids/Grid.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000